import { p } from 'framer-motion/client';

export const archivistData=[
            { name: 'Fr. Emile Gathier SJ', tenure: '(1936 - 1947)' },
            { name: 'Fr. Augustine Sauliere SJ', tenure: '(1948 - 1967)', photo:require('./assets/img/archivist/FrAugustine.png')  },
            { name: 'Fr. John Pujo SJ', tenure: '(1968 - 1977)', photo:require('./assets/img/archivist/FrJohnPujo.png') },
            { name: 'Fr. Puthota Rayanna SJ', tenure: '(1978 - 1981)',photo:require('./assets/img/archivist/FrPuthota.png')  },
            { name: 'Fr. Jan Slikerman SJ', tenure: '(1982- 1984)', photo:require('./assets/img/archivist/FrJan.png') },
            { name: 'Fr. V. M. Gnanapragasam SJ', tenure: '(1985 - 1996)', photo:require('./assets/img/archivist/FrGnanapragasam.png')  },
            { name: 'Fr. Guy Archambeaud SJ', tenure: '(1997 - 2004)', photo:require('./assets/img/archivist/FrGuy.png')  },
            { name: 'Fr. Joseph Antony Samy SJ', tenure: '(2005 - 2015)', photo:require('./assets/img/image.png'), note: 'From 2006 onwards, systematic work of scanning and computerizing the archival materials started.' },
            { name: 'Fr. Arulanandam Arockiam SJ', tenure: '(2015 - 2017)', photo:require('./assets/img/archivist/FrArulArokiyam.png') },
            { name: 'Fr. Das R. Jesu Michael SJ', tenure: '(2017-2018)', photo:require('./assets/img/archivist/FrDas.png')  },
            { name: 'Fr. Aruldoss Selvaraj SJ', tenure: '(2018 - 2021)', photo:require('./assets/img/archivist/FrAruldoss.png')  },
            { name: 'Fr. Joseph Antony Samy SJ', tenure: '(2021- )', photo:require('./assets/img/image.png')  },
          ]

export const materialData = [
  {
    "id": 1,
    "books": "Manuscripts"
  },
  {
    "id": 2,
    "books": "Old Madurai Mission (From 1583-1774)"
  },
  {
    "id": 3,
    "books": "Parish Diaries (In the Diocese of Trichy, Madurai, Sivagangai, Kottar, Palayamkottai and Thoothukudi)"
  },
  {
    "id": 4,
    "books": "Diaries of Persons (Jesuits \u2013 French, English, Irish, Belgian, Italian)"
  },
  {
    "id": 5,
    "books": "Parish files and other files"
  },
  {
    "id": 6,
    "books": "Shembaganur and Kodaikanal (Diaries from 1895-1980)"
  },
  {
    "id": 7,
    "books": "Photostats from Rome Photostats (letters about persons, churches and properties)"
  },
  {
    "id": 8,
    "books": "Bishops\u2019 Letters and Documents (A. Canoz, J.M. Barthe, A. Faisandier, J.P. Leonard, T. Roche, Agnisamy)"
  },
  {
    "id": 9,
    "books": "Palm Leaves (Olaichuvadi)"
  },
  {
    "id": 10,
    "books": "Monographs / Studies"
  },
  {
    "id": 11,
    "books": "Christianity and Church History"
  },
  {
    "id": 12,
    "books": "Protestantism"
  },
  {
    "id": 13,
    "books": "Far East"
  },
  {
    "id": 14,
    "books": "Sri Lanka"
  },
  {
    "id": 15,
    "books": "Pondicherry"
  },
  {
    "id": 16,
    "books": "Bombay, Bengal, Mangalore"
  },
  {
    "id": 17,
    "books": "Carnatic Mission"
  },
  {
    "id": 18,
    "books": "Malabar Province, Syrian Christians"
  },
  {
    "id": 19,
    "books": "Mission Letters"
  },
  {
    "id": 20,
    "books": "Society of Jesus (Books, Booklets, Menology)"
  },
  {
    "id": 21,
    "books": "St. Ignatius of Loyola"
  },
  {
    "id": 22,
    "books": "Spiritual Exercises of St. Ignatius"
  },
  {
    "id": 23,
    "books": "The Constitutions and the Rules of the Society of Jesus"
  },
  {
    "id": 24,
    "books": "Letters of Fathers General of the SJ"
  },
  {
    "id": 25,
    "books": "General Congregation (GC) of the SJ"
  },
  {
    "id": 26,
    "books": "Reviews \u2013 Jesuit Memorabilia, Acta Romana SJ"
  },
  {
    "id": 27,
    "books": "Bibliography and Catalogue of Books"
  },
  {
    "id": 28,
    "books": "New Madurai Mission Typed Letters"
  },
  {
    "id": 29,
    "books": "New Madurai Mission"
  },
  {
    "id": 30,
    "books": "Tamil Printed Books"
  },
  {
    "id": 31,
    "books": "Tamil Manuscripts (De Rossi, De Nobili and Beschi)"
  },
  {
    "id": 32,
    "books": "Religious Congregations (Men & Women)"
  },
  {
    "id": 33,
    "books": "Jesuit Publications \u2013 English"
  },
  {
    "id": 34,
    "books": "Jesuit Publications \u2013 Tamil"
  },
  {
    "id": 35,
    "books": "French India (about Hindu, Laws, Culture, Customs, Castes)"
  },
  {
    "id": 36,
    "books": "Jesuit Biographies"
  },
  {
    "id": 37,
    "books": "Catalogues, Caritas and MNL"
  },
  {
    "id": 38,
    "books": "Dictionaries (Many languages)"
  },
  {
    "id": 39,
    "books": "Mission History"
  },
  {
    "id": 40,
    "books": "Annales de la Propagation"
  },
  {
    "id": 41,
    "books": "Archivum Historicum Societatis Iesu"
  },
  {
    "id": 42,
    "books": "Monumenta Historica Societatis Iesu"
  },
  {
    "id": 43,
    "books": "Bibliotheca Instituti Historici Societatis Iesu"
  },
  {
    "id": 44,
    "books": "Varia \u2013 Catholic Directory"
  },
  {
    "id": 45,
    "books": "Education (Articles, Booklets, Books)"
  }
];

export const researchData = [
  {
    "id": 1,
    "name": "S.Venantius Fernando",
    "title": "The Impact of the Protuguese Padroado on the Indian Pearl Fishery Coast.",
    "university": "Pontificia Universita Urbaniana, Roma.",
    "year": 1977,
    "degree": "Phd"
  },
  {
    "id": 2,
    "name": "A. Lourdusamy",
    "title": "Thembaavaniyil Menaatu Ilakiya Thaakkam",
    "university": "Madras christytian College (MCC), Chennai.",
    "year": 1988,
    "degree": null
  },
  {
    "id": 3,
    "name": "K. Meenakshi",
    "title": "History of John De Britto",
    "university": "Madurai Kamaraj University (MKU), Madurai.",
    "year": 1989,
    "degree": null
  },
  {
    "id": 4,
    "name": "G. Arokia Raj",
    "title": "Madurai Province Jesuit Archives, Shembaganur",
    "university": "MCC",
    "year": 1990,
    "degree": null
  },
  {
    "id": 5,
    "name": "Y. Mallika",
    "title": "History of John Peter Leonard the First Archbishop of Madurai",
    "university": "MKU",
    "year": 1990,
    "degree": null
  },
  {
    "id": 6,
    "name": "G. Joseph Antony Samy",
    "title": "A History of Jesuits in the Madras Region 1545-1773",
    "university": "MCC",
    "year": 1990,
    "degree": null
  },
  {
    "id": 7,
    "name": "S. M. John Kennedy",
    "title": "Ecology of Human Settlements in some Tribal Villages",
    "university": "Pondicherry University",
    "year": 1991,
    "degree": null
  },
  {
    "id": 8,
    "name": "M. Elias",
    "title": "Study of Psycho – Social Correlates of Adult learning and Development in selected Literacy centres",
    "university": "University of Madras.",
    "year": 1991,
    "degree": null
  },
  {
    "id": 9,
    "name": "Rose Anne Antony",
    "title": "A study of the Management of H.S. education system in the state of TN with Respect to the Adm. behaviour of the Heads of the institutions",
    "university": "Sardar Patel University, Gujarat",
    "year": 1992,
    "degree": null
  },
  {
    "id": 10,
    "name": "M. Bernadette",
    "title": "Conversion in the Madura Region Since 1606",
    "university": "MKU",
    "year": 1992,
    "degree": null
  },
  {
    "id": 11,
    "name": "M. Alphonse",
    "title": "Padma Shri K.V. Peter, the Jesuit Post Master",
    "university": "MCC",
    "year": 1993,
    "degree": null
  },
  {
    "id": 12,
    "name": "M.A. Savariar",
    "title": "La Contribution du R. P. Jean Baptiste Trincal SJ",
    "university": "Bharathidasan University, Tirchy.",
    "year": 1994,
    "degree": null
  },
  {
    "id": 13,
    "name": "S. Ebinesar",
    "title": "Kristhavargalin Kalvi Pani",
    "university": "MKU",
    "year": 1994,
    "degree": null
  },
  {
    "id": 14,
    "name": "G. Francis Xavier Raj",
    "title": "L’Apport Francais à la Lexicographie Tamile",
    "university": "Jawaharlal Nehru University, New Delhi",
    "year": 1995,
    "degree": null
  },
  {
    "id": 15,
    "name": "P. Theresa",
    "title": "Life and works of Rev. Fr. J. Santiago SJ",
    "university": "MKU",
    "year": 1996,
    "degree": null
  },
  {
    "id": 16,
    "name": "M. Sebastian",
    "title": "A Study of the Socio – Economic conditions of the weaker sections of the society in TN",
    "university": "St. Joseph’s College (SJC), Tiruchi",
    "year": 1996,
    "degree": null
  },
  {
    "id": 17,
    "name": "John Bosco",
    "title": "Restoration of Our Lady of Lourdes Church, Tiruchi.",
    "university": "SJC",
    "year": 1998,
    "degree": null
  },
  {
    "id": 18,
    "name": "V. Alin Suneja",
    "title": "Conditions of the Sixteenth Century Tamilagam as Revealed in the letters of St. Francis Xavier 1542-1552",
    "university": "MCC",
    "year": 1998,
    "degree": null
  },
  {
    "id": 19,
    "name": "A. Joseph",
    "title": "Thembaavani- Kitheriammaal Ammaanai oru aivu",
    "university": "National college, Tiruchy",
    "year": 1999,
    "degree": null
  },
  {
    "id": 20,
    "name": "A. Maria Arul Raja",
    "title": "Dalit Encounter with their suffering: An Emancipatory interpretation of Mark 15:1-47, from Dalit Perspective",
    "university": "University of Madras.",
    "year": 2000,
    "degree": null
  },
  {
    "id": 21,
    "name": "Aloysius Idrudayam Ajai Mathew Naoko Yuzawa",
    "title": "Papers and Proceedings of Global conference Against Racism and Caste Based Discrimination",
    "university": "New Delhi.",
    "year": 2001,
    "degree": null
  },
  {
    "id": 22,
    "name": "Alphonse Manickam",
    "title": "Jesuits and Untouchability in Tamilnadu.",
    "university": "Paris.",
    "year": 2001,
    "degree": null
  },
  {
    "id": 23,
    "name": "Aloysius Irudayam Jayashree Mangubhai",
    "title": "Adivasi Human Rights Violations atrocities against Adivasis in Tamilnadu",
    "university": "Village Recontruction & Development project (VRDP).",
    "year": 2002,
    "degree": null
  },
  {
    "id": 24,
    "name": "M. A. Savariar",
    "title": "The Contribution of French to the Tamil Culture from XIX Century to XX Century",
    "university": "SJC",
    "year": 2002,
    "degree": null
  },
  {
    "id": 25,
    "name": "S. M. John Kennedy",
    "title": "Ethnobotanical elements of the Tribals in the Palani Hills with special Emphasis on the Traditional Medicinal Plants",
    "university": "St. Xavier’s College, Palayamkottai.",
    "year": 2003,
    "degree": null
  },
  {
    "id": 26,
    "name": "Aloysius Irudayam",
    "title": "The right to education of Adivasi Girls",
    "university": "Society for Integrated Devp. of Tribals (SIDT) Madurai.",
    "year": 2004,
    "degree": null
  },
  {
    "id": 27,
    "name": "N. Shanmuga Rani",
    "title": "Viviliya Inai thirumurayil Thobithu",
    "university": "MKU",
    "year": 2004,
    "degree": null
  },
  {
    "id": 28,
    "name": "M. Arockiasamy Xavier",
    "title": "Contribution of the Jesuits to Social Awakening in T N",
    "university": "SJC",
    "year": 2006,
    "degree": null
  },
  {
    "id": 29,
    "name": "P. Susai",
    "title": "Jesuit General Fr. Pedro Arrupe and his contribution to humanism.",
    "university": "BU",
    "year": 2007,
    "degree": null
  },
  {
    "id": 30,
    "name": "V. Sagayarasu",
    "title": "Punitha Germenammaal Aalayam Rayapuram oru aivu",
    "university": "Loyola College Chennai.",
    "year": 2007,
    "degree": null
  },
  {
    "id": 31,
    "name": "A. Thomas",
    "title": "Information and Communication Technology for Empowerment of Marginal Farmers in Dindigul",
    "university": "Gandhigram Rural University. (GRU )",
    "year": 2008,
    "degree": null
  },
  {
    "id": 32,
    "name": "Antony Raj",
    "title": "Discrimination Against Dalit christytians in Tamil Nadu",
    "university": "Madurai.",
    "year": null,
    "degree": null
  },
  {
    "id": 33,
    "name": "J.Z. Antonysamy",
    "title": "The foundation of christytianity in the Nayak and Maratha Kingdom of Thanjavur and the formation of the diocese of Thanjavur.",
    "university": "Pontificia Universita Della Santa Croce, Rome.",
    "year": 2013,
    "degree": null
  },
  {
    "id": 34,
    "name": "S. Aruldoss",
    "title": "The First Four Jesuit Bishops and their times (1846-1938)",
    "university": "Bishop Heber College, Tiruchi.",
    "year": 2013,
    "degree": null
  },
  {
    "id": 35,
    "name": "Anthony Muthu",
    "title": "History of Tiruchirapplli Diocese and its Varied Roles",
    "university": "MKU",
    "year": 1995,
    "degree": null
  },
  {
    "id": 36,
    "name": "C. Thanga Thilagavathi",
    "title": "Thoobanjali oru aivu",
    "university": "MKU",
    "year": null,
    "degree": null
  }
];

export const categoryData = [
  {
    "id": 1,
    "category": "Archives Catalogue",
    "subCategory": "Diaries of Persons"
  },
  {
    "id": 2,
    "category": "Archives Catalogue",
    "subCategory": "Bishops' Letters and Documents"
  },
  {
    "id": 3,
    "category": "Archives Catalogue",
    "subCategory": "Caritas"
  },
  {
    "id": 4,
    "category": "Archives Catalogue",
    "subCategory": "Goa"
  },
  {
    "id": 5,
    "category": "Archives Catalogue",
    "subCategory": "Goa"
  },
  {
    "id": 6,
    "category": "Archives Catalogue",
    "subCategory": "Immaculate Conception"
  },
  {
    "id": 7,
    "category": "Archives Catalogue",
    "subCategory": "Jesuit Publications"
  },
  {
    "id": 8,
    "category": "Archives Catalogue",
    "subCategory": "Kodaikanal"
  },
  {
    "id": 9,
    "category": "Archives Catalogue",
    "subCategory": "Malabar Province"
  },
  {
    "id": 10,
    "category": "Archives Catalogue",
    "subCategory": "Manuscripts"
  },
  {
    "id": 11,
    "category": "Archives Catalogue",
    "subCategory": "New Madurai Mission"
  },
  {
    "id": 12,
    "category": "Archives Catalogue",
    "subCategory": "New Madurai Mission Letters"
  },
  {
    "id": 13,
    "category": "Archives Catalogue",
    "subCategory": "Old Madurai Mission Letters"
  },
  {
    "id": 14,
    "category": "Archives Catalogue",
    "subCategory": "PALMERA"
  },
  {
    "id": 15,
    "category": "Archives Catalogue",
    "subCategory": "Parish Diaries"
  },
  {
    "id": 16,
    "category": "Archives Catalogue",
    "subCategory": "Parishes Files"
  },
  {
    "id": 17,
    "category": "Archives Catalogue",
    "subCategory": "Religious Orders (Tamil)"
  },
  {
    "id": 18,
    "category": "Archives Catalogue",
    "subCategory": "Reviews Jesuites"
  },
  {
    "id": 19,
    "category": "Archives Catalogue",
    "subCategory": "Sacred Heart Brothers"
  },
  {
    "id": 20,
    "category": "Archives Catalogue",
    "subCategory": "Sale Deeds Documents and Records"
  },
  {
    "id": 21,
    "category": "Archives Catalogue",
    "subCategory": "Shenbaganur - Kodaikanal"
  },
  {
    "id": 22,
    "category": "Archives Catalogue",
    "subCategory": "St.Anne's - Chennai"
  },
  {
    "id": 23,
    "category": "Archives Catalogue",
    "subCategory": "St.Anne's - Trichy"
  },
  {
    "id": 24,
    "category": "Archives Catalogue",
    "subCategory": "Syrian Christians"
  },
  {
    "id": 25,
    "category": "Archives Catalogue",
    "subCategory": "Tamil Manuscripts"
  },
  {
    "id": 26,
    "category": "Archives Catalogue",
    "subCategory": "Tamil Printed Books"
  },
  {
    "id": 27,
    "category": "Archives Catalogue",
    "subCategory": "Thoothan"
  },
  {
    "id": 28,
    "category": "Archives Catalogue",
    "subCategory": "Thoothan"
  },
  {
    "id": 29,
    "category": "Library Catalogue",
    "subCategory": "000 - Reference"
  },
  {
    "id": 30,
    "category": "Library Catalogue",
    "subCategory": "039 - General Encyelopedic works"
  },
  {
    "id": 31,
    "category": "Library Catalogue",
    "subCategory": "041 -Religious Biography"
  },
  {
    "id": 32,
    "category": "Library Catalogue",
    "subCategory": "042 - Secular Biography"
  },
  {
    "id": 33,
    "category": "Library Catalogue",
    "subCategory": "043 - Saints Biography"
  },
  {
    "id": 34,
    "category": "Library Catalogue",
    "subCategory": "100 Philosophy"
  },
  {
    "id": 35,
    "category": "Library Catalogue",
    "subCategory": "150 Psychology"
  },
  {
    "id": 36,
    "category": "Library Catalogue",
    "subCategory": "170 Ethics (Moral Philosophy)"
  },
  {
    "id": 37,
    "category": "Library Catalogue",
    "subCategory": "180 Ancient Medieval Oriental Philosophy"
  },
  {
    "id": 38,
    "category": "Library Catalogue",
    "subCategory": "200 Religion"
  },
  {
    "id": 39,
    "category": "Library Catalogue",
    "subCategory": "201 Jesus Christ"
  },
  {
    "id": 40,
    "category": "Library Catalogue",
    "subCategory": "202 Christianity"
  },
  {
    "id": 41,
    "category": "Library Catalogue",
    "subCategory": "203 Religious Life"
  },
  {
    "id": 42,
    "category": "Library Catalogue",
    "subCategory": "220 Scripture"
  },
  {
    "id": 43,
    "category": "Library Catalogue",
    "subCategory": "221 Old Testament"
  },
  {
    "id": 44,
    "category": "Library Catalogue",
    "subCategory": "222 New Testament"
  },
  {
    "id": 45,
    "category": "Library Catalogue",
    "subCategory": "223 Gospels & Acts (Commentaries)"
  },
  {
    "id": 46,
    "category": "Library Catalogue",
    "subCategory": "230 Christianity - Christian Theology"
  },
  {
    "id": 47,
    "category": "Library Catalogue",
    "subCategory": "231 Spiritual Theology"
  },
  {
    "id": 48,
    "category": "Library Catalogue",
    "subCategory": "235 Mystical Theology"
  },
  {
    "id": 49,
    "category": "Library Catalogue",
    "subCategory": "237 Monastic Spirituality"
  },
  {
    "id": 50,
    "category": "Library Catalogue",
    "subCategory": "238 Catechism"
  },
  {
    "id": 51,
    "category": "Library Catalogue",
    "subCategory": "240 Devotional Theology"
  },
  {
    "id": 52,
    "category": "Library Catalogue",
    "subCategory": "244 Mariology"
  },
  {
    "id": 53,
    "category": "Library Catalogue",
    "subCategory": "251 Liturgy/Homilies/Sermon"
  },
  {
    "id": 54,
    "category": "Library Catalogue",
    "subCategory": "252 Meditation/Prayer/Contemplation"
  },
  {
    "id": 55,
    "category": "Library Catalogue",
    "subCategory": "253 Pastoral Theology"
  },
  {
    "id": 56,
    "category": "Library Catalogue",
    "subCategory": "253.1 Liberation Theology"
  },
  {
    "id": 57,
    "category": "Library Catalogue",
    "subCategory": "255 Religious Congregation & Orders"
  },
  {
    "id": 58,
    "category": "Library Catalogue",
    "subCategory": "255.1 Jesuits"
  },
  {
    "id": 59,
    "category": "Library Catalogue",
    "subCategory": "256 Constitution (SJ) GC Letters"
  },
  {
    "id": 60,
    "category": "Library Catalogue",
    "subCategory": "256.1 Jesuit History"
  },
  {
    "id": 61,
    "category": "Library Catalogue",
    "subCategory": "257 Jesuit Education"
  },
  {
    "id": 62,
    "category": "Library Catalogue",
    "subCategory": "257.1 Jesuit Formation"
  },
  {
    "id": 63,
    "category": "Library Catalogue",
    "subCategory": "257.2 Priestly Formation"
  },
  {
    "id": 64,
    "category": "Library Catalogue",
    "subCategory": "258 Spiritual Exercises (Jesuit Spirituality)"
  },
  {
    "id": 65,
    "category": "Library Catalogue",
    "subCategory": "258.1 Retreat"
  },
  {
    "id": 66,
    "category": "Library Catalogue",
    "subCategory": "259 Pastoral Care"
  },
  {
    "id": 67,
    "category": "Library Catalogue",
    "subCategory": "265 Sacraments"
  },
  {
    "id": 68,
    "category": "Library Catalogue",
    "subCategory": "266 Mission"
  },
  {
    "id": 69,
    "category": "Library Catalogue",
    "subCategory": "266.1 Jesuits in England"
  },
  {
    "id": 70,
    "category": "Library Catalogue",
    "subCategory": "266.2 Missions in India"
  },
  {
    "id": 71,
    "category": "Library Catalogue",
    "subCategory": "266.3 Bengal Mission"
  },
  {
    "id": 72,
    "category": "Library Catalogue",
    "subCategory": "266.4 Madurai Mission"
  },
  {
    "id": 73,
    "category": "Library Catalogue",
    "subCategory": "266.5 Bombay Mission"
  },
  {
    "id": 74,
    "category": "Library Catalogue",
    "subCategory": "266.6 Jesuits in Karnataka"
  },
  {
    "id": 75,
    "category": "Library Catalogue",
    "subCategory": "266.7 Madurai Province"
  },
  {
    "id": 76,
    "category": "Library Catalogue",
    "subCategory": "267 Jesuit Saints - 267.1 Ignatius of Loyola"
  },
  {
    "id": 77,
    "category": "Library Catalogue",
    "subCategory": "267 Jesuit Saints - 267.2 St John De Britto"
  },
  {
    "id": 78,
    "category": "Library Catalogue",
    "subCategory": "267 Jesuit Saints - 267.3 St Francis Xavier"
  },
  {
    "id": 79,
    "category": "Library Catalogue",
    "subCategory": "267 Jesuit Saints - 267.4 Jesuit Biography"
  },
  {
    "id": 80,
    "category": "Library Catalogue",
    "subCategory": "267.1 Ignatius of Loyola"
  },
  {
    "id": 81,
    "category": "Library Catalogue",
    "subCategory": "267.2 St John De Britto"
  },
  {
    "id": 82,
    "category": "Library Catalogue",
    "subCategory": "267.3 St Francis Xavier"
  },
  {
    "id": 83,
    "category": "Library Catalogue",
    "subCategory": "267.4 Jesuit Biography"
  },
  {
    "id": 84,
    "category": "Library Catalogue",
    "subCategory": "270 Church History"
  },
  {
    "id": 85,
    "category": "Library Catalogue",
    "subCategory": "275 History of Christianity in Asia"
  },
  {
    "id": 86,
    "category": "Library Catalogue",
    "subCategory": "275.1 Church in India"
  },
  {
    "id": 87,
    "category": "Library Catalogue",
    "subCategory": "275.2 Church in Tamil Nadu"
  },
  {
    "id": 88,
    "category": "Library Catalogue",
    "subCategory": "275.4 Church in Sri Lanka"
  },
  {
    "id": 89,
    "category": "Library Catalogue",
    "subCategory": "282 Roman Catholic Church"
  },
  {
    "id": 90,
    "category": "Library Catalogue",
    "subCategory": "282.1 Canon Law"
  },
  {
    "id": 91,
    "category": "Library Catalogue",
    "subCategory": "282.2 Papal Teaching"
  },
  {
    "id": 92,
    "category": "Library Catalogue",
    "subCategory": "282.3 Councils"
  },
  {
    "id": 93,
    "category": "Library Catalogue",
    "subCategory": "284 Protestantism"
  },
  {
    "id": 94,
    "category": "Library Catalogue",
    "subCategory": "290 Comparative Religion (Other Religions)"
  },
  {
    "id": 95,
    "category": "Library Catalogue",
    "subCategory": "294 Hinduism (Bhagavad Gita Epics Advaita)"
  },
  {
    "id": 96,
    "category": "Library Catalogue",
    "subCategory": "294.1 Indian Philosophy"
  },
  {
    "id": 97,
    "category": "Library Catalogue",
    "subCategory": "294.2 Indian Spirituality"
  },
  {
    "id": 98,
    "category": "Library Catalogue",
    "subCategory": "297 Islam"
  },
  {
    "id": 99,
    "category": "Library Catalogue",
    "subCategory": "298 Buddhism"
  },
  {
    "id": 100,
    "category": "Library Catalogue",
    "subCategory": "299 Spirituality in General"
  },
  {
    "id": 101,
    "category": "Library Catalogue",
    "subCategory": "299.1 Spiritual Narratives"
  },
  {
    "id": 102,
    "category": "Library Catalogue",
    "subCategory": "299.2 Mission History"
  },
  {
    "id": 103,
    "category": "Library Catalogue",
    "subCategory": "300 Social Science"
  },
  {
    "id": 104,
    "category": "Library Catalogue",
    "subCategory": "300.1 Secularism"
  },
  {
    "id": 105,
    "category": "Library Catalogue",
    "subCategory": "301 Sociology & Anthropology"
  },
  {
    "id": 106,
    "category": "Library Catalogue",
    "subCategory": "305 Women"
  },
  {
    "id": 107,
    "category": "Library Catalogue",
    "subCategory": "307 Tribes & Ethnic Groups"
  },
  {
    "id": 108,
    "category": "Library Catalogue",
    "subCategory": "307.1 Caste System"
  },
  {
    "id": 109,
    "category": "Library Catalogue",
    "subCategory": "308 Indian Culture"
  },
  {
    "id": 110,
    "category": "Library Catalogue",
    "subCategory": "309 Human Rights"
  },
  {
    "id": 111,
    "category": "Library Catalogue",
    "subCategory": "309.1 Social Justice"
  },
  {
    "id": 112,
    "category": "Library Catalogue",
    "subCategory": "320 Political Science"
  },
  {
    "id": 113,
    "category": "Library Catalogue",
    "subCategory": "330 Economics"
  },
  {
    "id": 114,
    "category": "Library Catalogue",
    "subCategory": "348 Law ( Statutes Regulations Cases )"
  },
  {
    "id": 115,
    "category": "Library Catalogue",
    "subCategory": "370 Education"
  },
  {
    "id": 116,
    "category": "Library Catalogue",
    "subCategory": "376 Moral Education"
  },
  {
    "id": 117,
    "category": "Library Catalogue",
    "subCategory": "376 Moral Education"
  },
  {
    "id": 118,
    "category": "Library Catalogue",
    "subCategory": "377 Rel Education (Youth)"
  },
  {
    "id": 119,
    "category": "Library Catalogue",
    "subCategory": "378 Rel Education (Youth)"
  },
  {
    "id": 120,
    "category": "Library Catalogue",
    "subCategory": "379 Rel Education (Youth)"
  },
  {
    "id": 121,
    "category": "Library Catalogue",
    "subCategory": "380 Communication (Media)"
  },
  {
    "id": 122,
    "category": "Library Catalogue",
    "subCategory": "380 Rel Education (Youth)"
  },
  {
    "id": 123,
    "category": "Library Catalogue",
    "subCategory": "381 Rel Education (Youth)"
  },
  {
    "id": 124,
    "category": "Library Catalogue",
    "subCategory": "382 Rel Education (Youth)"
  },
  {
    "id": 125,
    "category": "Library Catalogue",
    "subCategory": "383 Rel Education (Youth)"
  },
  {
    "id": 126,
    "category": "Library Catalogue",
    "subCategory": "384 Rel Education (Youth)"
  },
  {
    "id": 127,
    "category": "Library Catalogue",
    "subCategory": "385 Rel Education (Youth)"
  },
  {
    "id": 128,
    "category": "Library Catalogue",
    "subCategory": "386 Rel Education (Youth)"
  },
  {
    "id": 129,
    "category": "Library Catalogue",
    "subCategory": "387 Rel Education (Youth)"
  },
  {
    "id": 130,
    "category": "Library Catalogue",
    "subCategory": "388 Rel Education (Youth)"
  },
  {
    "id": 131,
    "category": "Library Catalogue",
    "subCategory": "389 Rel Education (Youth)"
  },
  {
    "id": 132,
    "category": "Library Catalogue",
    "subCategory": "390 Rel Education (Youth)"
  },
  {
    "id": 133,
    "category": "Library Catalogue",
    "subCategory": "391 Rel Education (Youth)"
  },
  {
    "id": 134,
    "category": "Library Catalogue",
    "subCategory": "392 Rel Education (Youth)"
  },
  {
    "id": 135,
    "category": "Library Catalogue",
    "subCategory": "393 Rel Education (Youth)"
  },
  {
    "id": 136,
    "category": "Library Catalogue",
    "subCategory": "394 Rel Education (Youth)"
  },
  {
    "id": 137,
    "category": "Library Catalogue",
    "subCategory": "395 Rel Education (Youth)"
  },
  {
    "id": 138,
    "category": "Library Catalogue",
    "subCategory": "396 Rel Education (Youth)"
  },
  {
    "id": 139,
    "category": "Library Catalogue",
    "subCategory": "397 Rel Education (Youth)"
  },
  {
    "id": 140,
    "category": "Library Catalogue",
    "subCategory": "398 Folklore"
  },
  {
    "id": 141,
    "category": "Library Catalogue",
    "subCategory": "398 Rel Education (Youth)"
  },
  {
    "id": 142,
    "category": "Library Catalogue",
    "subCategory": "399 Rel Education (Youth)"
  },
  {
    "id": 143,
    "category": "Library Catalogue",
    "subCategory": "400 Rel Education (Youth)"
  },
  {
    "id": 144,
    "category": "Library Catalogue",
    "subCategory": "401 Rel Education (Youth)"
  },
  {
    "id": 145,
    "category": "Library Catalogue",
    "subCategory": "402 Rel Education (Youth)"
  },
  {
    "id": 146,
    "category": "Library Catalogue",
    "subCategory": "503 Sciences (Miscellaneous)"
  },
  {
    "id": 147,
    "category": "Library Catalogue",
    "subCategory": "577 Ecology"
  },
  {
    "id": 148,
    "category": "Library Catalogue",
    "subCategory": "580 Plants"
  },
  {
    "id": 149,
    "category": "Library Catalogue",
    "subCategory": "610 Medical Science"
  },
  {
    "id": 150,
    "category": "Library Catalogue",
    "subCategory": "620 Engineering"
  },
  {
    "id": 151,
    "category": "Library Catalogue",
    "subCategory": "658 General Management & 690 Buildings"
  },
  {
    "id": 152,
    "category": "Library Catalogue",
    "subCategory": "700.1 Arts (Miscellaneous)"
  },
  {
    "id": 153,
    "category": "Library Catalogue",
    "subCategory": "720 Architecture"
  },
  {
    "id": 154,
    "category": "Library Catalogue",
    "subCategory": "755 Painting (Religion)"
  },
  {
    "id": 155,
    "category": "Library Catalogue",
    "subCategory": "780 Music"
  },
  {
    "id": 156,
    "category": "Library Catalogue",
    "subCategory": "791 Dancing"
  },
  {
    "id": 157,
    "category": "Library Catalogue",
    "subCategory": "804 Literature on Tamil"
  },
  {
    "id": 158,
    "category": "Library Catalogue",
    "subCategory": "895 Literature of East & Southeast Asia"
  },
  {
    "id": 159,
    "category": "Library Catalogue",
    "subCategory": "909 World History (Countries)"
  },
  {
    "id": 160,
    "category": "Library Catalogue",
    "subCategory": "909.1 World History (Nations)"
  },
  {
    "id": 161,
    "category": "Library Catalogue",
    "subCategory": "910 Geography & Travel"
  },
  {
    "id": 162,
    "category": "Library Catalogue",
    "subCategory": "947 Russia (East Europe)"
  },
  {
    "id": 163,
    "category": "Library Catalogue",
    "subCategory": "950 History of Asia"
  },
  {
    "id": 164,
    "category": "Library Catalogue",
    "subCategory": "950 History of Asia - 950.1 Far East"
  },
  {
    "id": 165,
    "category": "Library Catalogue",
    "subCategory": "950.2 Sri Lanka"
  },
  {
    "id": 166,
    "category": "Library Catalogue",
    "subCategory": "950.3 Indo-Portuguese"
  },
  {
    "id": 167,
    "category": "Library Catalogue",
    "subCategory": "951 China"
  },
  {
    "id": 168,
    "category": "Library Catalogue",
    "subCategory": "952 Japan"
  },
  {
    "id": 169,
    "category": "Library Catalogue",
    "subCategory": "954 History of India"
  },
  {
    "id": 170,
    "category": "Library Catalogue",
    "subCategory": "954.1 Tamil Nadu"
  },
  {
    "id": 171,
    "category": "Library Catalogue",
    "subCategory": "954.2 Madras"
  },
  {
    "id": 172,
    "category": "Library Catalogue",
    "subCategory": "990 General History / 990.1 America (North & South"
  },
  {
    "id": 173,
    "category": "Library Catalogue",
    "subCategory": "Fr Pedro Arrupe SJ"
  },
  {
    "id": 174,
    "category": "Tamil Catalogue",
    "subCategory": "Tamil Poems (Kavithaigal)"
  },
  {
    "id": 175,
    "category": "Tamil Catalogue",
    "subCategory": "Arts of India ( India Kalaigal )"
  },
  {
    "id": 176,
    "category": "Tamil Catalogue",
    "subCategory": "Arutchathanangal"
  },
  {
    "id": 177,
    "category": "Tamil Catalogue",
    "subCategory": "Awareness"
  },
  {
    "id": 178,
    "category": "Tamil Catalogue",
    "subCategory": "Awarness"
  },
  {
    "id": 179,
    "category": "Tamil Catalogue",
    "subCategory": "Botany"
  },
  {
    "id": 180,
    "category": "Tamil Catalogue",
    "subCategory": "Catechism"
  },
  {
    "id": 181,
    "category": "Tamil Catalogue",
    "subCategory": "Christian Literature"
  },
  {
    "id": 182,
    "category": "Tamil Catalogue",
    "subCategory": "Christian Songs"
  },
  {
    "id": 183,
    "category": "Tamil Catalogue",
    "subCategory": "Christianity"
  },
  {
    "id": 184,
    "category": "Tamil Catalogue",
    "subCategory": "Common in Tamil Language"
  },
  {
    "id": 185,
    "category": "Tamil Catalogue",
    "subCategory": "Comparative Grammer (Oppilakkanam)"
  },
  {
    "id": 186,
    "category": "Tamil Catalogue",
    "subCategory": "Dioceses"
  },
  {
    "id": 187,
    "category": "Tamil Catalogue",
    "subCategory": "Drama"
  },
  {
    "id": 188,
    "category": "Tamil Catalogue",
    "subCategory": "Education"
  },
  {
    "id": 189,
    "category": "Tamil Catalogue",
    "subCategory": "Essays on literature (Ilakiya Katturaigal)"
  },
  {
    "id": 190,
    "category": "Tamil Catalogue",
    "subCategory": "Eucharist (Narkarunai Veera Sabai)"
  },
  {
    "id": 191,
    "category": "Tamil Catalogue",
    "subCategory": "General knowledge (Essays)"
  },
  {
    "id": 192,
    "category": "Tamil Catalogue",
    "subCategory": "Hinduism"
  },
  {
    "id": 193,
    "category": "Tamil Catalogue",
    "subCategory": "History of Church"
  },
  {
    "id": 194,
    "category": "Tamil Catalogue",
    "subCategory": "History of India"
  },
  {
    "id": 195,
    "category": "Tamil Catalogue",
    "subCategory": "History of Tamil Literature (Tamil Ilakkiya Varalaru)"
  },
  {
    "id": 196,
    "category": "Tamil Catalogue",
    "subCategory": "History of Temples"
  },
  {
    "id": 197,
    "category": "Tamil Catalogue",
    "subCategory": "Holy Bible"
  },
  {
    "id": 198,
    "category": "Tamil Catalogue",
    "subCategory": "Human Rights"
  },
  {
    "id": 199,
    "category": "Tamil Catalogue",
    "subCategory": "Jesuit History"
  },
  {
    "id": 200,
    "category": "Tamil Catalogue",
    "subCategory": "Leaders in India"
  },
  {
    "id": 201,
    "category": "Tamil Catalogue",
    "subCategory": "Martyr Deva Sahayam Pillai"
  },
  {
    "id": 202,
    "category": "Tamil Catalogue",
    "subCategory": "Media Education"
  },
  {
    "id": 203,
    "category": "Tamil Catalogue",
    "subCategory": "Medicine"
  },
  {
    "id": 204,
    "category": "Tamil Catalogue",
    "subCategory": "Mother Mary (Mariyannai)"
  },
  {
    "id": 205,
    "category": "Tamil Catalogue",
    "subCategory": "Nattar Vazhakkatriyal&Panpaadu"
  },
  {
    "id": 206,
    "category": "Tamil Catalogue",
    "subCategory": "Politics"
  },
  {
    "id": 207,
    "category": "Tamil Catalogue",
    "subCategory": "Politics (Aracial)"
  },
  {
    "id": 208,
    "category": "Tamil Catalogue",
    "subCategory": "Prayer Book"
  },
  {
    "id": 209,
    "category": "Tamil Catalogue",
    "subCategory": "Proverbs"
  },
  {
    "id": 210,
    "category": "Tamil Catalogue",
    "subCategory": "Religions of Our Country"
  },
  {
    "id": 211,
    "category": "Tamil Catalogue",
    "subCategory": "Robert De Nobili SJ"
  },
  {
    "id": 212,
    "category": "Tamil Catalogue",
    "subCategory": "Saints"
  },
  {
    "id": 213,
    "category": "Tamil Catalogue",
    "subCategory": "Secular Biography"
  },
  {
    "id": 214,
    "category": "Tamil Catalogue",
    "subCategory": "Short Stories"
  },
  {
    "id": 215,
    "category": "Tamil Catalogue",
    "subCategory": "Social Justice (Samuga Neethi)"
  },
  {
    "id": 216,
    "category": "Tamil Catalogue",
    "subCategory": "Spiritual"
  },
  {
    "id": 217,
    "category": "Tamil Catalogue",
    "subCategory": "Spiritual Exercises"
  },
  {
    "id": 218,
    "category": "Tamil Catalogue",
    "subCategory": "Spiritual Short Stories"
  },
  {
    "id": 219,
    "category": "Tamil Catalogue",
    "subCategory": "Tamil Literature"
  },
  {
    "id": 220,
    "category": "Tamil Catalogue",
    "subCategory": "Tamil Literature Stories"
  },
  {
    "id": 221,
    "category": "Tamil Catalogue",
    "subCategory": "Tamil Nadu"
  },
  {
    "id": 222,
    "category": "Tamil Catalogue",
    "subCategory": "Tamil Novel"
  },
  {
    "id": 223,
    "category": "Tamil Catalogue",
    "subCategory": "Theology"
  },
  {
    "id": 224,
    "category": "Tamil Catalogue",
    "subCategory": "Thesis (Aaivu Katturaigal)"
  },
  {
    "id": 225,
    "category": "Tamil Catalogue",
    "subCategory": "Thiruchabai"
  },
  {
    "id": 226,
    "category": "Tamil Catalogue",
    "subCategory": "Thirukkural"
  },
  {
    "id": 227,
    "category": "Tamil Catalogue",
    "subCategory": "World Tamil Conference (Ulaga Tamil Manadu)"
  }
];
